import { defineStore } from 'pinia'

export const useProfileStore = defineStore('profile', {
  state: () => ({
    programLink: 'https://www.podiumeducation.com/students',
    salesforceId: '',
  }),
  persist: true,
  actions: {
    setProgramLink(programLink) {
      this.programLink = programLink
    },
    setSalesforceId(salesforceId) {
      this.salesforceId = salesforceId
    },
  },
})
